<template>
  <div class="Home">
    <div class="container">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="logo">
            <a href="https://learnapp.co/home/?ref=APPRDD"><img src="@/assets/img/logo.png"/></a>
            <span></span>
            <a href="https://zerodha.com/"><img src="@/assets/img/logoZerodha.png"/></a>
         </div>
          <div class="logo-mobile">
            <a href="https://learnapp.co/home/?ref=APPRDD"><img src="@/assets/img/logo-mobile.png"/></a>
            <span></span>
            <a href="https://zerodha.com/"><img src="@/assets/img/zerodha-mobile.png"/></a>
          </div>
          <div class="left-header-menu">
            <a href="#" class="running-menu" @click="$emit('sidebarStatus')"><img class="running-menu-img" src="@/assets/img/menu.png"/><span>Menu</span></a>
            <a href="https://learnapp.co/courses/all/?ref=APPRDD" class="course-menu"><img src="@/assets/img/mentors.png"/><span>Courses</span></a>
            <a href="https://learnapp.co/live/all/?ref=APPRDD" class="course-menu"><img src="@/assets/img/category2.png"><span>Live Classes</span></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',

  props: {
    profile: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
  .Home {
    padding: 13px 0;
    text-align: center;
    background-color: white;
    width: 100vw;
    z-index: 999;
    -webkit-box-shadow: 0 2px 4px 3px rgba(126,139,156,.14);
    box-shadow: 0 2px 4px 3px rgba(126,139,156,.14);
    position: fixed;

    .LessonNavigation::after {
      display: none;
    }

   .left-header-menu .course-menu img {
    height: 34px;
  }

    .logo-mobile {
      display: none;
    }

    .logo {
      margin-left: -15%;
      display: inline-block;
    }

    .logo {
      a{
        font-size: 29px;
        &:last-child{
          img{
            height: 19px;
          }
        }
      }
      span {
        height: 65px;
        position: relative;
        margin-right: 28px;
        padding: 8px 14px 6px 2px;
        border-right: 2px solid #d9dde2;
        }
      img {
        height: 27px;
      }
    }

    .left-header-menu {
      float: left;
      margin-left: -180px;
    }

    .left-header-menu a {
      color: #7e8b9c;
      display: inline-block;
      font-size: 16px;
      line-height: 38px;
      margin: 0 25px 0 0;
      text-decoration: none;
    }

    .left-header-menu a img {
      height: 18px;
      margin: 0 10px 0 0;
    }

    /*** Responsive ***/
    @media (min-width: 1413px) and (max-width: 1550px) {
         .left-header-menu {
      margin-left: -130px;
    }
    }

    @media (min-width: 992px) and (max-width: 1413px) {
      .left-header-menu {
      margin-left: 0;
    }
    }

     @media (max-width: 767px) {
       .left-header-menu {
      margin-left: 180px;
    }
     }

    @media (max-width: 991px) {
      .logo {
        display: none;
      }

      .logo-mobile {
        display: inline-block;
        a{
          font-size: 29px;
          &:last-child{
            img{
              height: 27px;
            }
          }
        }
        span {
          height: 65px;
          position: relative;
          margin-right: 28px;
          padding: 8px 14px 6px 2px;
          border-right: 2px solid #d9dde2;
        }
        img {
          height: 27px;
        }
      }


    .left-header-menu {
      margin-left: -110px;
    }
    }

    @media (max-width: 767px) {
       .left-header-menu {
      margin-left: -90px;
    }
    }

    @media (max-width: 575px) {
      .left-header-menu a {
        margin: 0 10px 0 0;
      }

      .left-header-menu span {
        display: none;
      }

      .login-user-info > img {
        margin: 0;
      }
      .left-header-menu {
      margin-left: 0;
    }
    }
  }
</style>




// WEBPACK FOOTER //
// src/modules/Home/components/LessonNavigation.vue